module.exports = __webpack_public_path__ + "img/user-avatar-box.88ab2d87.svg";